import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '/src/views/home/index.vue'
// import LoginIndex from '/src/views/login/index.vue'
import Login from '/src/views/login/index.vue';
import Register from '/src/views/login/register.vue'
import FileInfo from '/src/views/login/fileInfo.vue'
import Forget from '/src/views/login/forget.vue'
import home_home from '/src/views/home/home.vue'
import Classes from '/src/views/home/classes/index.vue'
import Mall from '/src/views/home/mall/index.vue'
import MallClassify from '/src/views/home/mall/classify.vue'
import Cart from '/src/views/home/cart/index.vue'
import productDetail from '/src/views/home/mall/detail.vue'
import Pay from '/src/views/home/mall/pay.vue'
import leasonDetail from '/src/views/home/classes/detail.vue'
import ClassPack from '/src/views/home/classPack/index.vue'
import UserInfo from '/src/views/home/userInfo/index.vue'
import OrderList from '/src/views/home/userInfo/orderList.vue'
import User from '/src/views/home/userInfo/user.vue'
import EditUser from '/src/views/home/userInfo/editUser.vue'
import userCard from '/src/views/home/userInfo/card.vue'
import userIntegral from '/src/views/home/userInfo/integral.vue'
import Package from '/src/views/home/userInfo/package.vue'
import childInfo from '/src/views/home/userInfo/child.vue'
import EditChild from '/src/views/home/userInfo/editChild.vue'
import OrderDetail from '/src/views/home/userInfo/orderDetail.vue'
import OrderStatus from '/src/views/home/userInfo/orderStatus.vue'
import SelectCourse from '/src/views/home/classes/selectCourse.vue'
import Contact from '/src/views/home/contact/index.vue'
import About from '/src/views/home/about.vue'
import ParentClass from '/src/views/home/parentClass.vue'
import Party from '/src/views/home/party.vue'
import Events from '/src/views/home/events.vue'
import HelpCenter from '/src/views/home/helpCenter.vue'
import MessageDetail from '/src/views/home/messageDetail.vue'
import PayFail from '/src/views/home/userInfo/payFail.vue'
import Term from '/src/views/login/term.vue'
import PaySuccess from '/src/views/home/userInfo/paySuccess.vue'
import changePwd from '/src/views/home/userInfo/changePwd.vue'
import Bespoke from '/src/views/home/bespoke.vue'
import Event from '/src/views/home/eventPack/index.vue';
import EventsDetail from '/src/views/home/eventPack/detail.vue';
import SelectEvents from '/src/views/home/eventPack/selectCourse.vue';
import EventOrder from '/src/views/home/userInfo/eventOrder.vue';
import EventOrderDetail from '/src/views/home/userInfo/eventOrderDetail.vue';
import Parent from '/src/views/home/parentPack/index.vue';
import ParentDetail from '/src/views/home/parentPack/detail.vue';
import SelectParent from '/src/views/home/parentPack/selectCourse.vue';
import parentOrderDetail from '/src/views/home/userInfo/parentOrderDetail.vue';

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'layout',
	redirect: '/home/home',
  },
  {
  	  path:'/login',
  	   name: 'login',
  	  component:Login,
  },
  {
  	  path:'/fileInfo',
  	   name: 'fileInfo',
  	  component:FileInfo,
  },
  {
  	  path:'/forget',
  	   name: 'forget',
  	  component:Forget,
  },
  {
  	  path:'/term',
  	  component:Term,
  },
  {
  	  path:'/register',
  	   name: 'register',
  	  component:Register,
  },
  {
	  path:'/home',
	   name: 'home',
	  component:Home,
	  children: [
	  	{
	  		path: 'home',
	  		component: home_home,
	  	},
		{
			path: 'classes',
			component: Classes,
		},
		{
			path: 'event',
			component: Event,
		},
	  	{
	  		path: 'mall',
	  		component: Mall,
	  	},
		{
			path: 'mall/classfiy',
			component: MallClassify,
		},
		{
			path: 'mall/detail',
			component: productDetail,
		},
		{
	  		path: 'cart',
	  		component: Cart,
	  	},
		{
	  		path: 'pay',
	  		component: Pay,
	  	},
		{
			path: 'classify/detail',
			component: leasonDetail,
		},
		{
			path: 'classify/selectCourse',
			component: SelectCourse,
		},
		{
			path: 'event/detail',
			component: EventsDetail,
		},
		{
			path: 'event/selectCourse',
			component: SelectEvents,
		},
		{
			path: 'parent',
			component: Parent,
		},
		{
			path: 'parent/detail',
			component: ParentDetail,
		},
		{
			path: 'parent/selectCourse',
			component: SelectParent,
		},
		{
			path: 'classPack',
			component: ClassPack,
		},
		{
			path: 'contact',
			component: Contact,
		},
		{
			path: 'about',
			component: About,
		},
		{
			path: 'parentClass',
			component: ParentClass,
		},
		{
			path: 'party',
			component: Party,
		},
		{
			path: 'bespoke',
			component: Bespoke,
		},
		{
			path: 'events',
			component: Events,
		},
		{
			path: 'helpCenter',
			component: HelpCenter,
		},
		{
			path: 'messageDetail',
			component: MessageDetail,
		},
		
		{
			path: 'userInfo',
			component: UserInfo,
			children:[
				 {
					 path: 'orderList',
					 component: OrderList,
				 },
				 {
					 path: 'eventOrder',
					 component: EventOrder,
				 },
				 {
					 path: 'eventOrderDetail',
					 component: EventOrderDetail,
				 },
				 {
					 path: 'parentsOrderDetail',
					 component: parentOrderDetail,
				 },
				  {
					 path: 'user',
					 component: User,
				 },
				 {
					 path: 'editUser',
					 component: EditUser,
				 },
				  {
					 path: 'card',
					 component: userCard,
				 },
				 {
					 path: 'integral',
					 component: userIntegral,
				 },
				 {
					 path: 'package',
					 component: Package,
				 },
				 {
					 path: 'child',
					 component: childInfo,
				 },
				 {
					 path: 'editChild',
					 component: EditChild,
				 },
				  {
					 path: 'orderStatus',
					 component: OrderStatus,
				 },
				 {
					 path: 'orderDetail',
					 component: OrderDetail,
				 },
				  {
					 path: 'payFail',
					 component: PayFail,
				 },
				 {
				 	path: 'paySuccess',
				 	component: PaySuccess,
				 },
				 {
				 	path: 'changePwd',
				 	component: changePwd,
				 },
			 ],
			 redirect: '/home/userInfo/orderList',
		},
	  ],
	  redirect: '/home/home',
  },
]

const router = new VueRouter({
  
  base: process.env.BASE_URL,
  routes
})
const originalPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default router
